import React from 'react';
import PropTypes from 'prop-types';
import TableItem from './TableItem';

const TableItems = ({ tableItems, handleEditFormOpen, handleAnswerFormLoad  }) => {
    // Verifica si tableItems es un array
  if (!Array.isArray(tableItems)) {
    console.error('tableItems debe ser un array');
    return null; // O cualquier otro manejo de error que desees
  }
  const allTableItems = tableItems.map(tableItem => (
    <TableItem key={tableItem.id} tableItem={tableItem} handleEditFormOpen={handleEditFormOpen} handleAnswerFormLoad={handleAnswerFormLoad} />
  ));

  return <tbody>{allTableItems}</tbody>;
};

TableItems.propTypes = {
  tableItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleEditFormOpen: PropTypes.func,
};

TableItems.defaultProps = {
  tableItems: [
    {
      id: 1,
      subject: 'A new rating has been received',
      category: 'Marketing',
      assignee: 'Erwin',
      priority: 'Medium',
      status: 'Open',
      update: false,
      creation_date : '',
      answers_number: 0,
      has_docs: false
    },
  ],
};

export default TableItems;
